import React from 'react';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import {useFormContext} from 'react-hook-form';

import {translations} from 'presentation/translations-new';
import {usePasswordRequirements} from 'presentation/pages/public/hooks';
import {PublicFlowEnum} from 'presentation/pages/public/constants/PublicFlowEnum';
import {PasswordInput} from '../PasswordInput';
import {PasswordRequirementsList} from './PasswordRequirements/PasswordRequirementsList';
import {PasswordStrengthBar} from './PasswordRequirements';
import {PasswordWithStrengthValidationProps} from './types';

const {newPassword, password, repeatPassword, repeatNewPassword} =
	translations['pt-br'].publicFlow.formLabels;
const {newPasswordPlaceholder, passwordPlaceholder} =
	translations['pt-br'].publicFlow.formPlaceholders;

export function PasswordWithStrengthValidation({flowType}: PasswordWithStrengthValidationProps) {
	const {
		isRequirementsVisible,
		passwordRef,
		isStrenghtBarVisible,
		setIsRequirementsVisible,
		setIsStrenghtBarVisible,
	} = usePasswordRequirements();
	const {trigger, watch} = useFormContext();
	const passwordValue = watch('password');

	const isForgotPasswordFlow = flowType === PublicFlowEnum.FORGOT_PASSWORD;

	const passLabel = isForgotPasswordFlow ? newPassword : password;
	const repeatPassLabel = isForgotPasswordFlow ? repeatNewPassword : repeatPassword;
	const passPlaceholder = isForgotPasswordFlow ? newPasswordPlaceholder : passwordPlaceholder;

	return (
		<Stack gap={2}>
			<Stack>
				<Typography variant="label" component="label" htmlFor="password">
					{passLabel}
				</Typography>
				<PasswordInput
					slotProps={{
						htmlInput: {
							maxLength: 6,
							onBlur: () => trigger('repeatPassword'),
						},
					}}
					name="password"
					inputRef={passwordRef}
					autoComplete="new-password"
					hideHelperText
					label={passPlaceholder}
				/>
			</Stack>
			{isStrenghtBarVisible ? <PasswordStrengthBar /> : null}
			{isRequirementsVisible ? <PasswordRequirementsList /> : null}
			<Stack>
				<Typography variant="label" component="label" htmlFor="repeatPassword">
					{repeatPassLabel}
				</Typography>
				<PasswordInput
					slotProps={{
						htmlInput: {
							maxLength: 6,
							onFocus: () => {
								if (passwordValue?.length <= 0) {
									setIsStrenghtBarVisible(false);
								}
								setIsRequirementsVisible(false);
								trigger('repeatPassword');
							},
						},
					}}
					name="repeatPassword"
					autoComplete="new-password"
					label={passPlaceholder}
					onPaste={e => e.preventDefault()}
				/>
			</Stack>
		</Stack>
	);
}
